import React from 'react';

import { deprecate } from 'react-is-deprecated';

import PropTypes from 'prop-types';

import querystring from 'querystring';

/**
 *  Displays KBB dealer ratings
 *
 */
function IframeKBBDealerRatings({
    height,
    owner: {
        id,
        rating: {
            value,
            apiKey,
            apiUrl,
        } = {},
    } = {},
    showCount = false,
    widgetType = 'large',
    width,
    ...rest
}) {
    if (!value) return null;

    const params = {
        apiKey,
        svocId: id,
        nocount: showCount,
    };

    const urlParams = querystring.stringify(params);

    const source = `${apiUrl}/widget/ratings/${widgetType}?` + urlParams;

    return (
        <iframe
            data-cmp="IframekbbDealerRatings"
            title={'IframekbbDealerRatings-' + id}
            width={width || 270}
            height={height || 250}
            className="border-0"
            src={source}
            {...rest}
        />
    );
}

IframeKBBDealerRatings.propTypes = {
    /**
    *   Standard Owner Object. Requires `id` and `rating` object
    */
    owner: PropTypes.object.isRequired,
    /**
    *   Type of widget to display
    */
    widgetType: PropTypes.oneOf([
        'large',
        'stacked',
    ]),
    /**
    *   DEPRECATED
    */
    frameBorder: deprecate(PropTypes.bool, '`frameborder` is deprecated in standard HTML. Use CSS.'),
    /**
    *   Width of iFrame (`large`, `stacked` only)
    */
    width: PropTypes.number,
    /**
    *   Height of iFrame (`large`, `stacked` only)
    */
    height: PropTypes.number,
    /**
    *   DEPRECATED
    */
    scrolling: deprecate(PropTypes.string, '`scrolling` is deprecated in standard HTML. Use CSS if necessary.'),
};

export default IframeKBBDealerRatings;
